import { ProductGroups } from "../modules/productGroups";

export const ProductGroupsPage = () => {
  return <ProductGroups />;
};
